(function(){
  if (window.__ah2CartInit) return; window.__ah2CartInit = true;
  var q = function(s, r){ return (r||document).querySelector(s); };
  var qa = function(s, r){ return Array.prototype.slice.call((r||document).querySelectorAll(s)); };
  var fmt = function(c){ try{ if(window.Shopify&&Shopify.formatMoney) return Shopify.formatMoney(c,(window.theme&&theme.moneyFormat)||'${{amount}}'); }catch(e){} return '$'+(c/100).toFixed(2); };

  /* arrival dates: today + min .. today + max */
  var arrive = function(){
    var el = q('.quick-cart [data-arrive-dates]'); if(!el) return;
    var qc = q('.quick-cart'); var a = parseInt(qc.dataset.arriveMin||'4',10), b = parseInt(qc.dataset.arriveMax||'8',10);
    var m = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    var d1 = new Date(); d1.setDate(d1.getDate()+a); var d2 = new Date(); d2.setDate(d2.getDate()+b);
    var txt = m[d1.getMonth()]+' '+d1.getDate()+' to '+(d1.getMonth()===d2.getMonth()?'':m[d2.getMonth()]+' ')+d2.getDate();
    if ((document.documentElement.lang||'').toLowerCase().indexOf('es')===0 || /^\/es(\/|$)/.test(location.pathname)) {
      var me = ['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'];
      txt = d1.getMonth()===d2.getMonth() ? 'entre el '+d1.getDate()+' y el '+d2.getDate()+' de '+me[d2.getMonth()] : 'entre el '+d1.getDate()+' de '+me[d1.getMonth()]+' y el '+d2.getDate()+' de '+me[d2.getMonth()];
    }
    if (el.textContent !== txt) el.textContent = txt;
  };

  /* also-bought slider: scroll-snap track + arrows + dots */
  var slider = function(){
    var box = q('.quick-cart [data-also]'); if(!box || box.__ah2) return; box.__ah2 = true;
    var track = q('[data-also-track]', box), slides = qa('.ah2-slide', track), dots = q('[data-also-dots]', box);
    var prev = q('[data-also-prev]', box), next = q('[data-also-next]', box);
    if(!slides.length) return;
    dots.innerHTML = slides.map(function(_,i){ return '<span class="ah2-dot'+(i===0?' is-active':'')+'"></span>'; }).join('');
    var idx = function(){ return Math.round(track.scrollLeft / Math.max(1, slides[0].offsetWidth + 10)); };
    var paint = function(){ var i = idx(); qa('.ah2-dot', dots).forEach(function(d,k){ d.classList.toggle('is-active', k===i); }); prev.disabled = i<=0; next.disabled = i>=slides.length-1; };
    var go = function(i){ i = Math.max(0, Math.min(slides.length-1, i)); track.scrollTo({left: i*(slides[0].offsetWidth+10), behavior:'smooth'}); };
    prev.addEventListener('click', function(){ go(idx()-1); });
    next.addEventListener('click', function(){ go(idx()+1); });
    var t; track.addEventListener('scroll', function(){ clearTimeout(t); t=setTimeout(paint,80); });
    paint();
  };

  /* shipping protection toggle: ON = theme add flow, OFF = theme remove flow */
  document.addEventListener('click', function(e){
    var sw = e.target.closest('[data-protection-toggle]'); if(!sw) return;
    e.preventDefault(); sw.classList.add('is-busy');
    if (sw.getAttribute('aria-checked') === 'true') {
      var line = q('.quick-cart [data-protection-line] [data-remove-item]');
      if (line) { line.click(); } else { sw.classList.remove('is-busy'); }
    } else {
      var add = q('.quick-cart [data-protection-add]');
      if (add) { add.click(); } else { sw.classList.remove('is-busy'); }
    }
  });

  /* keep the footer in sync after the theme swaps the items */
  var t2 = null;
  /* stepper number mirrors the theme input right away */
  document.addEventListener('click', function(e){
    var b = e.target.closest('.quick-cart .ah2-qty .quantity-input__button'); if(!b) return;
    setTimeout(function(){ var w = b.closest('.ah2-qty'); var i = q('.quantity-input__input', w), n = q('[data-qty-mirror]', w); if(i && n && n.textContent !== i.value) n.textContent = i.value; }, 0);
  });
  var sync = function(){
    arrive(); slider();
    var sw = q('.quick-cart [data-protection-toggle]');
    if (sw) { var v = q('.quick-cart [data-protection-line]') ? 'true' : 'false'; if (sw.getAttribute('aria-checked') !== v) sw.setAttribute('aria-checked', v); if (sw.classList.contains('is-busy')) sw.classList.remove('is-busy'); }
    var row = q('.quick-cart [data-cart-savings]');
    if(row){ var v = (q('[data-cart-savings-value]', row)||{}).textContent||''; row.hidden = /^\s*-?\s*\$?0(?:[.,]00)?\s*$/.test(v); }
    clearTimeout(t2); t2 = setTimeout(function(){
      var el = q('.quick-cart [data-cart-total]'); if(!el) return;
      fetch('/cart.js',{credentials:'include'}).then(function(r){return r.json()}).then(function(c){ var v = fmt(c.total_price); if (el.textContent !== v) el.textContent = v; }).catch(function(){});
    }, 250);
  };
  var qc = q('.quick-cart');
  var busy = false;
  var timerOnly = function(ms){ return ms.every(function(m){ var el = m.target.nodeType === 1 ? m.target : m.target.parentNode; return el && el.closest && el.closest('[data-ah2-timer]'); }); };
  if (qc) new MutationObserver(function(ms){ if (timerOnly(ms)) return; if (busy) return; busy = true; setTimeout(function(){ busy = false; sync(); }, 60); }).observe(qc, {childList:true, subtree:true});
  sync();

  /* speed: open the drawer at once on add-to-cart, hide removed lines at once,
     and refresh the drawer as soon as Shopify answers (the theme only refreshes
     after the apps' own cart calls, ~0.5-1 s later). */
  var secId = qc && qc.getAttribute('data-section-id');
  var instance = function(){ try { return (Shopify.theme.sections.instances||[]).filter(function(i){ return i.id === secId; })[0]; } catch(e){ return null; } };
  var openDrawer = function(){
    var inst = instance();
    if (inst && typeof inst.openQuickCart === 'function') { try { inst.openQuickCart(); return; } catch(e){} }
    var i = q('[data-js-cart-icon]'); if (i) i.click();
  };
  var seq = 0;
  var refresh = function(){
    if (!secId) return; var my = ++seq;
    var c = q('.quick-cart'); if (c) c.classList.add('ah2-loading');
    fetch('/cart?section_id=' + encodeURIComponent(secId), {credentials:'include'}).then(function(r){ return r.text(); }).then(function(html){
      if (my !== seq) return;
      var d = new DOMParser().parseFromString(html, 'text/html');
      [['.quick-cart__items'], ['.quick-cart__heading sup'], ['[data-cart-total]'], ['[data-cart-savings-value]']].forEach(function(k){
        var a = q('.quick-cart ' + k[0]), b = d.querySelector(k[0]);
        if (a && b && a.innerHTML !== b.innerHTML) a.innerHTML = b.innerHTML;
      });
      if (!q('.quick-cart .quick-cart__items') && d.querySelector('.quick-cart__items')) {
        var cont = q('.quick-cart .quick-cart__container'), nc = d.querySelector('.quick-cart__container');
        if (cont && nc) cont.innerHTML = nc.innerHTML;
      }
    }).catch(function(){}).then(function(){ if (my === seq) { var c2 = q('.quick-cart'); if (c2) c2.classList.remove('ah2-loading'); } });
  };
  /* the live theme.liquid writes cart.total_discount into the savings row on cart:updated; re-render from the section right after */
  document.addEventListener('cart:updated', function(){ setTimeout(refresh, 0); });
  /* free gifts follow the kit quantity (Kaching deal q5b2: 1 Puffer Pouch per kit).
     After any cart write, set each bundle's gift line(s) to kit qty x per-kit count.
     Kaching's discount already makes that many pouches free. Uses the unwrapped fetch. */
  var GIFT_PER_UNIT = {'q5b2': 1};
  var rawFetch = window.__ah2RawFetch || window.fetch;
  var giftSync = function(){
    return rawFetch('/cart.js', {credentials:'include'}).then(function(r){ return r.json(); }).then(function(c){
      var main = {}, gifts = {};
      (c.items || []).forEach(function(it){
        var p = it.properties && it.properties.__kaching_bundles; if (!p) return;
        try { p = JSON.parse(p); } catch(e){ return; }
        if (!p.id || !(p.deal in GIFT_PER_UNIT)) return;
        if (p.main) main[p.id] = (main[p.id] || 0) + it.quantity;
        else if (p.gift) { (gifts[p.id] = gifts[p.id] || {deal: p.deal, lines: []}).lines.push(it); }
      });
      var up = {}, n = 0;
      Object.keys(gifts).forEach(function(id){
        var g = gifts[id], want = (main[id] || 0) * GIFT_PER_UNIT[g.deal];
        var have = g.lines.reduce(function(s, x){ return s + x.quantity; }, 0);
        if (have === want) return;
        g.lines.forEach(function(x, i){ up[x.key] = i === 0 ? want : 0; }); n++;
      });
      if (!n) return false;
      return rawFetch('/cart/update.js', {method:'POST', credentials:'include', headers:{'Content-Type':'application/json'}, body: JSON.stringify({updates: up})})
        .then(function(r){ if (!r.ok) return false; return r.json().then(function(nc){
          qa('[data-js-cart-count]').forEach(function(el){ var v = String(nc.item_count); if (el.textContent.trim() !== v) el.textContent = v; });
          try { document.dispatchEvent(new CustomEvent('ah2:gifts-synced', {detail: nc})); } catch(e){}
          return true; }, function(){ return true; }); });
    }).catch(function(){ return false; });
  };
  var isCartWrite = function(u){ return /\/cart\/(add|change|update)(\.js)?(\?|$)/.test(u || ''); };
  if (window.fetch && !window.__ah2Fetch) {
    window.__ah2Fetch = true;
    var of = window.fetch; window.__ah2RawFetch = of;
    window.fetch = function(input, init){
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var m = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      var p = of.apply(this, arguments);
      if (m === 'POST' && isCartWrite(url)) {
        if (/\/cart\/add/.test(url)) { openDrawer(); var c = q('.quick-cart'); if (c) c.classList.add('ah2-loading'); }
        p.then(function(r){ if (r && r.ok) refresh(); giftSync().then(function(ch){ if (ch) refresh(); }); }).catch(function(){});
      }
      return p;
    };
  }
  if (window.XMLHttpRequest && !window.__ah2Xhr) {
    window.__ah2Xhr = true;
    var oo = XMLHttpRequest.prototype.open, os = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function(m, u){ this.__ah2 = (String(m).toUpperCase() === 'POST' && isCartWrite(u)) ? String(u) : null; return oo.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function(){
      if (this.__ah2) {
        var u = this.__ah2;
        if (/\/cart\/add/.test(u)) openDrawer();
        this.addEventListener('load', function(){ if (this.status >= 200 && this.status < 300) refresh(); giftSync().then(function(ch){ if (ch) refresh(); }); });
      }
      return os.apply(this, arguments);
    };
  }
  /* removed line: hide it and update the count right away */
  document.addEventListener('click', function(e){
    var b = e.target.closest('.quick-cart [data-remove-item]'); if (!b) return;
    var line = b.closest('[data-input-item]'); if (!line || line.hasAttribute('data-protection-line')) return;
    line.classList.add('ah2-gone');
    var sup = q('.quick-cart .quick-cart__heading sup'), qty = parseInt((q('[data-qty-mirror]', line) || q('.ah2-qty-chip', line) || {textContent:'1'}).textContent.replace(/\D/g,''), 10) || 1;
    if (sup) { var n = Math.max(0, (parseInt(sup.textContent, 10) || 0) - qty); sup.textContent = n; }
  }, true);

  /* cart timer (off unless the section setting is on): one countdown per visit, kept in sessionStorage */
  var tick = function(){
    var bars = qa('.quick-cart [data-ah2-timer]'); if (!bars.length) return;
    var hasItems = !!q('.quick-cart .quick-cart__items');
    bars.forEach(function(bar){ if (bar.hidden === hasItems) bar.hidden = !hasItems; });
    if (!hasItems) return;
    var mins = parseInt(bars[0].dataset.minutes || '10', 10), now = Date.now(), end = 0;
    try { end = parseInt(sessionStorage.getItem('ah2TimerEnd') || '0', 10); } catch(e){}
    if (!end || end <= now) { end = now + mins * 60000; try { sessionStorage.setItem('ah2TimerEnd', String(end)); } catch(e){} }
    var left = Math.max(0, Math.round((end - now) / 1000)), txt = String(Math.floor(left / 60)).padStart(2, '0') + ':' + String(left % 60).padStart(2, '0');
    bars.forEach(function(bar){ var c = q('[data-ah2-timer-clock]', bar); if (c && c.textContent !== txt) c.textContent = txt; });
  };
  if (q('.quick-cart [data-ah2-timer]')) { tick(); setInterval(tick, 1000); }

  /* /cart is redirected here with ?cart=open (see sections/main-cart.liquid): open the drawer */
  if (/[?&]cart=open/.test(location.search)) {
    var open = function(){ var i = q('[data-js-cart-icon]'); if(i) i.click(); };
    if (document.readyState === 'complete') setTimeout(open, 400); else window.addEventListener('load', function(){ setTimeout(open, 400); });
  }
})();
